module.exports = __webpack_public_path__ + "img/20.8a77374.png";